<template lang='pug'>
//- LINE-Bundle-Page
div(:class='$style[`cc-line-bundle-container`]')
  div(v-if='!loginStatus' :class='$style[`cc-line-bundle-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 請先登入
        span.no-wrap 再綁定LINE
      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 【首次註冊建議使用LINE快速登入】完成一次性綁定動作後，即可透過LINE使用「Cancell 醫抗癌」的服務與功能喔。

    div(:class='$style[`cc-banner-button`]')
      button(
        tabindex='0'
        aria-label='註冊或登入'
        :class='$style[`cc-line-bundle-redirect`]'
        title='註冊或登入'
        @click='handleClickLogin') 註冊或登入


  div(v-else :class='$style[`cc-line-bundle-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap LINE帳戶
        span.font-doctor-theme 綁定成功！

      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 已完成綁定，您現在可以透過LINE使用Cancell醫抗癌的服務與功能。

    div(:class='$style[`cc-banner-button`]')
      router-link(
        role='button'
        tabindex='0'
        aria-label='開始使用'
        to='/sideeffect/record'
        :class='$style[`cc-line-bundle-redirect`]'
        title='開始使用') 開始使用


</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import {
  putLineOfficialBundle,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: 'LINE帳戶綁定',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/line/bundle',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/line/bundle',
      }],
    };
  },

  data() {
    return {
      lineId: this.$route.query.l || null,
    }
  },

  created() {
    if (!this.$route.query.l) {
      this.$router.replace({
        name: 'error404',
      }).catch(() => true);
    } else if (!this.loginStatus) {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    } else {
      this.completeLineAccountBundle()
    }
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClickLogin() {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    },

    completeLineAccountBundle() {
      if (this.$route.query.l) {
        const CONFIG = {
          lineid: this.lineId,
          auth_id: this.loginDjangoId,
          account_type: this.loginProfile.account_login
        };

        putLineOfficialBundle('', CONFIG)
          .then((res) => {
            console.log('putLineOfficialBundle', res);
          })
          .catch((err) => {
            // console.log('putLineOfficialBundle err', err);
            this.changePopBoxStatus({
              active: true,
              include: 'warnError',
            });
          });
      } else {
        this.$router.replace({
          name: 'error404',
        }).catch(() => true);
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    loginStatus() {
      // alert('loginStatus change!');
      if (this.loginStatus) {
        this.completeLineAccountBundle();
      }
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/info/lineBundle.scss';
</style>
